import { useLayoutEffect, useRef } from 'react';
import { css } from '@emotion/react';
import { createFocusTrap } from 'focus-trap';
/**
 *
 */
export const FocusTrap = (props) => {
    const { children, disabled, options, onEnter, onExit, focusCheckDelay = 750, fullHeight = true, ...rest } = props;
    const ref = useRef(null);
    const trapRef = useRef(null);
    useLayoutEffect(() => {
        if (ref.current) {
            trapRef.current = createFocusTrap(ref.current, {
                clickOutsideDeactivates: true,
                fallbackFocus: ref.current,
                checkCanFocusTrap: () => new Promise((resolve) => {
                    setTimeout(resolve, focusCheckDelay);
                }),
                document: ref.current.getRootNode(),
                ...options,
            });
        }
    }, [focusCheckDelay, options]);
    useLayoutEffect(() => {
        const container = ref.current;
        if (disabled) {
            trapRef.current?.deactivate();
            onExit && container && onExit(container);
        }
        else {
            if (trapRef.current && container) {
                trapRef.current.activate();
                onEnter && onEnter(container);
            }
        }
    }, [disabled, onEnter, onExit]);
    useLayoutEffect(() => () => {
        trapRef.current?.deactivate();
        onExit && ref.current && onExit(ref.current);
    }, [onExit]);
    return (<div css={fullHeight
            ? css `
              height: 100%;
            `
            : undefined} className="cy-focustrap" ref={ref} {...rest}>
      {children}
    </div>);
};
